import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { IonContent, LoadingController, Platform } from '@ionic/angular';
import { debounceTime, first } from 'rxjs/operators';
import { Navigator } from 'src/app/services/routing/navigator';
import { AffiliateTrackerCallbackParams } from 'src/app/interfaces/affliation-interface';
import { DepositMainLabels } from 'src/app/interfaces/deposit-main-labels';
import { BalanceModel } from 'src/app/models/balance-model';
import { DepositMainModel } from 'src/app/models/deposit-models';
import { AccountBalanceService } from 'src/app/services/balance/account-balance.service';
import { CashierContentService } from 'src/app/services/cashier/cashier-content.service';
import { CashierService } from 'src/app/services/cashier/cashier.service';
import { WithdrawalService } from 'src/app/services/cashier/withdrawal.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { EventsService } from 'src/app/services/event/event.service';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { WithdrawalBaseComponent } from '../withdrawal-base/withdrawal-base.component';
import { DEPOSIT_PATTERN } from 'src/app/services/customFormValidators';
import { Subscription } from 'rxjs';


declare var window:any
declare var PayWithMyBank: any;

// interface CapacitorPluginPaywithmybank {
//   selectBankWidget( options: { value: string}): Promise<{ value: string}>;
// }
// const PayWithMyBankCapacitor = registerPlugin<CapacitorPluginPaywithmybank>('CapacitorPluginPaywithmybank');

@Component({
  selector: 'app-withdrawal-pay-with-my-bank',
  templateUrl: './withdrawal-pay-with-my-bank.component.html',
  styleUrls: ['./withdrawal-pay-with-my-bank.component.scss'],
})


export class WithdrawalPayWithMyBankComponent extends WithdrawalBaseComponent implements OnInit {
  @ViewChild(IonContent, { static: false }) content: IonContent;

  public error = null;
  public labels: DepositMainLabels;
  public enterCounts = 0;
  public enterPressed: boolean;
  public hasAccount: boolean = false;
  public withdrawalForm: FormGroup;
  public amount: AbstractControl;
  public selectedAccount: any;
  public currency_code: any;
  public payment_type_code: any;
  public accounts: Array<any> = [];
  public accountBalances: BalanceModel;
  public isPageLoaded: boolean = false;
  private customerObj: any = {};
  private balanceSubscription;
  public environmentName: string;
  public loading: any;
  public disableWithdrawButton: boolean = false;
  public delayBankWidgetLoad;
  public withdrawalLoadingMsg;
  private subscriptions: Subscription[] = [];

  constructor(
    public cashierService: CashierService,
    public cashierContentService: CashierContentService,
    public navigator: Navigator,
    public events: EventsService,
    public withdrawService: WithdrawalService,
    public balanceService: AccountBalanceService,
    public utils: UtilsService,
    public configService: ConfigService,
    public successMessageService: SuccessMessageService,
    public userSessionService:UserSessionService,
    public loadingController: LoadingController,
    public platform: Platform
  ) {
    super();
    this.successMessageService.clearMessage();
    this.error = null;
    this.labels = new DepositMainModel();
    this.cashierService.setupPayWithMyBank();        
  }
  
  @HostListener('document:keypress', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.enterPressed = true;
      this.enterCounts++;
    }
  }
  ngAfterViewInit() {
    this.cashierContentService.getPageConfig('paywithmybank').then((response: DepositMainLabels) => {
      this.labels = response;
    });
  }

  ngOnInit() {
    this.withdrawalForm = new FormGroup(
      {
          accountList: new FormControl('', [Validators.required]),
          amount: new FormControl('', {
              validators: [Validators.pattern(DEPOSIT_PATTERN), Validators.required],
              updateOn: 'change'
          }),
          customerAccountID: new FormControl(''),
          currency_code: new FormControl(''),
          payment_type_code: new FormControl('')
      }

    );    

    this.amount = this.withdrawalForm.get('amount');
    this.delayBankWidgetLoad = this.configService.getConfig().FEATURE_WITHDRAWAL_ONLINE_BANK_WIDGET_DEALY ? this.configService.getConfig().FEATURE_WITHDRAWAL_ONLINE_BANK_WIDGET_DEALY : 1;
    this.withdrawalLoadingMsg = this.configService.getConfig().FEATURE_WITHDRAWAL_ONLINE_BANK_LOADING_MSG ? this.configService.getConfig().FEATURE_WITHDRAWAL_ONLINE_BANK_LOADING_MSG : 'Loading...';
  }

  async showLoading() {
    this.loading = await this.loadingController.create({
      message: this.withdrawalLoadingMsg,
      duration: this.delayBankWidgetLoad * 1000
    });

    this.loading.present();
  }

  ionViewWillEnter() {
    this.showLoading();
    setTimeout(() => {
      this.onGetAccounts();
    }, this.delayBankWidgetLoad * 1000);
  }

  ionViewDidEnter() {
    this.successMessageService.clearMessage();
    this.onGetBalance();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
    
    if (typeof PayWithMyBank !== 'undefined') {
      PayWithMyBank.removePanelListener();
    }   
  }

  private setCustomerObject() {
    let country = this.cashierService.customer.address.country;
    if (country === "USA") {
      country = "US";
    }
    if (country === "CAN") {
      country = "CA";
    }
    this.customerObj = {
      "customerId": this.cashierService.customer.customerId,
      "externalId": this.cashierService.customer.customerId,
      "merchantId": this.configService.getConfig().FEATURE_PWMB_MERCHANT_ID,
      "name": this.cashierService.customer.firstName + " " + this.cashierService.customer.lastName,
      // "driverLicense": {},
      "address": {
        "address1": this.cashierService.customer.address.street,
        "address2": this.cashierService.customer.address.street2,
        "city": this.cashierService.customer.address.city,
        "state": this.cashierService.customer.address.state,
        "zip": this.cashierService.customer.address.postalCode,
        "country": country
      },
      // TODO: get country code based on country for phone number
      "phone": "+1" + this.cashierService.customer.address.phoneNumber,
      "email": this.cashierService.customer.email,
      "dateOfBirth": this.cashierService.customer.birthDate
      // "createdAt": this.cashierProvider.customer.createdDate,
      // "updatedAt": ""
    }
    
    if (this.accountBalances.hasEnrollDate()) {
      let enrollDate = this.accountBalances.getEnrollDate();
      this.customerObj['enrollDate'] = enrollDate.getTime();
    }

  }

  onGetBalance() {
    const balanceSubscription = this.balanceService.getBalance().subscribe(
      (balance: BalanceModel) => {
        if (balance) {
          this.accountBalances = balance;
        }
      }
    );
    this.error = null;
    this.subscriptions.push(balanceSubscription);
  }

  public onGetAccounts(newAccountAdded: boolean = false){
    const listAccountSubscription = this.cashierService.callListAccounts().pipe(first()).subscribe((response: any) => {
      if (response && !!response.result){
        this.accounts = response.payload.filter(account =>  account.paymentTypeCode === "PWB").map((account, key) => {
            account.id = key;
            return account;
        });

        if (this.accounts.length) {
          this.hasAccount = true;
          this.selectedAccount = this.accounts[0].id;
          if (this.balanceSubscription) {
            this.balanceSubscription.unsubscribe();
          }
        } else {
          if(!this.platform.is('capacitor')){
          this.loadBankSelectorWidget();}
        else{
        return this.isPageLoaded=true; 
         }
        }
        
        
      }
      this.isPageLoaded = true;
    }, (error) => {
      this.error = this.handleError(error);
      this.content.scrollToTop(10);
    });

    this.subscriptions.push(listAccountSubscription);
  }
  openPWMBMobile(){
   this.loadBankSelectorWidget()
  }
  onPayWithMyBankPage() {
    this.navigator.navigateTo("DepositPaywithmybankComponent", {}, { navigateBackPage: "WithdrawalPayWithMyBankComponent" });
    return false;
  }
  
  onSubmit() {
    this.disableWithdrawButton = true;
    // Handling multiple enter clicks on mobile
    this.checkEnterSubmission();
  }
  
  checkEnterSubmission() {
    if (this.enterPressed === true) {
      if (this.enterCounts == 1) {
        setTimeout(() => { this.onWithdraw() }, 200);
      }
      this.disableWithdrawButton = false;
      this.enterPressed = false;

    } else {
      setTimeout(() => { this.onWithdraw() }, 200);
    }
  }

  onWithdraw() {
    this.disableWithdrawButton = true;
    this.successMessageService.clearMessage();
    this.error = null;

    let withdrawalFormObj: any = this.withdrawalForm.value;
    withdrawalFormObj.amount = parseFloat(this.withdrawalForm.get('amount').value).toFixed(2);
    withdrawalFormObj.currency_code = this.cashierService.customer.preferredCurrency.currencyCode;
    withdrawalFormObj.customerAccountID = this.accounts[this.selectedAccount].customerAccountID; 
    withdrawalFormObj.payment_type_code = "PWB";   

    const withdrawSubscription = this.withdrawService.callWithdraw(withdrawalFormObj).pipe(debounceTime(300)).subscribe(
      (response: any) => {
        if (response && !!response.result) {

          // send the withdrawal event
          let depositEventData: AffiliateTrackerCallbackParams = {
            customer_id: this.cashierService.customer.customerId,
            amount: this.withdrawalForm.get('amount').value
          }
          setTimeout(() => this.events.publish('event:withdraw', depositEventData), 2000);

          this.amount.setValue('');
          this.amount.markAsPristine();
          this.amount.markAsUntouched();

          this.successMessageService.setMessage('Your withdrawal request has been received.');

          this.balanceService.updateBalance();

          this.content.scrollToTop();
          this.disableWithdrawButton = false;
        }
      },
      (error) => {
        // handle all deposit errors in base
        this.error = this.handleError(error);
        // this.logger.log("callWithdraw error = ", error);
        this.content.scrollToTop();
        this.disableWithdrawButton = false;
      }
    )

    this.subscriptions.push(withdrawSubscription);
    // Clearing the enterCounts after 3 seconds each time a withdrawal request is made.
    setTimeout(() => {
      this.enterCounts = 0;
    }, 3000);

    this.error = null;
  }

  private loadBankSelectorWidget() {
    this.balanceSubscription = this.balanceService.getBalance().subscribe(
      (balance: BalanceModel) => {
        if (balance) {
          this.accountBalances = balance;
          this.setCustomerObject();

          // should we send SSN?
          if (this.configService.getConfig().FEATURE_PWMB_TAXID && this.configService.getConfig().FEATURE_PWMB_TAXID == '0') {
            this.initAddAccount();
          } else {
            this.cashierService.getPwbEncryptedSsn().pipe(first()).subscribe(
              (response: any) => {
                if (response && !!response.result) {
                  if(response.payload && response.payload.ssnEncrypted){
                    this.customerObj.taxId = response.payload.ssnEncrypted
                  }
                  return this.initAddAccount();
                }
              },
              (error) => {
                this.error = error;
              }
            );
          }
        }
      }
    );

    this.subscriptions.push(this.balanceSubscription);
  }

  // Use for populating the cashier PayWithMyBank method page
  private initAddAccount() {
    // FYI:
    // accountAdditionalInfo1 is the routingNumber
    // accountAdditionalInfo2 is the bankName
    // accountAdditionalInfo3 is the last 4 digits of the account number

    let payWithMyBankOptions = {
      closeButton: false,
      dragAndDrop: false,
      widgetContainerId: "pwbw-container" //Page element container for the widget
    };

    let establishData: any = {
      accessId: this.configService.getConfig().FEATURE_PWMB_ACCESS_ID,
      customer: this.customerObj,
      merchantId: this.configService.getConfig().FEATURE_PWMB_MERCHANT_ID,
      merchantReference: Date.now() + `|${this.userSessionService.sessionToken}`,
      paymentType: 'Deferred',
      returnUrl: '#return',
      cancelUrl: '#cancel'
    };

    if (this.configService.getConfig().FEATURE_PWMB_COUNTRY) {
      establishData.country = this.configService.getConfig().FEATURE_PWMB_COUNTRY;
    }

    if (this.configService.getConfig().FEATURE_PWMB_CURRENCY) {
      establishData.currency = this.configService.getConfig().FEATURE_PWMB_CURRENCY;
    }
    if( this.platform.is('capacitor')) {
     return this.invokeMobileAddAccount(establishData);   
    } 
    const pwbSubscription =  this.cashierService.getPwbRequestSignature(this.generateQuery(establishData)).subscribe(
      (response: any) => {
        if (response && !!response.result) {
          establishData['requestSignature'] = response.payload;
          PayWithMyBank.selectBankWidget(establishData, payWithMyBankOptions);
        }
      },
      (error) => {
        this.error = this.handleError(error);
      }
    );

    this.subscriptions.push(pwbSubscription);

    let vm = this;

    PayWithMyBank.addPanelListener(function (command, event) {
      if (command === 'event' && event.type === 'new_location') {
        let cancel = event.data.indexOf('#cancel') === 0;
        let accountAdded = event.data.indexOf('#return') === 0;

        if (cancel || accountAdded) {
          // alert('Here you need to handle the redirection.');

          // Prevent redirection
          event.preventDefault();

          // Refresh account list on add
          if (accountAdded) {
            setTimeout(() => {
              vm.onGetAccounts();
            }, 1000);
          }

          PayWithMyBank.removePanelListener();
        }
      }
    });
  }
  public invokeMobileAddAccount(data) {
    const pwbSignatureSubscription =  this.cashierService.getPwbRequestSignature(this.generateQuery(data)).subscribe((response: any) => {
      if (response && !!response.result) {
        // this.loading?.dismiss();
        data['requestSignature'] = response.payload;
        if( "undefined" !== typeof this.configService.getConfig().FEATURE_PWMB_TRUSTLY_ENV) {
          data['env'] = this.configService.getConfig().FEATURE_PWMB_TRUSTLY_ENV;
        }
        if( this.platform.is('capacitor')) {
          window.cordova.plugins.PayWithMyBank.selectBankWidget( data, () => {
            setTimeout( () => {
              this.onGetAccounts( true);
            }, 2*1000);
          }, (err) => {
            console.log( 'PWMB: selectBankWidget error: ', err);
          });
        } else {
          console.log( 'in mobile context the web calls should not happen.');
//          PayWithMyBank.selectBankWidget(data, this.payWithMyBankOptions);
        }
      }
    },(error) => {
      this.error = this.handleError(error);
      this.content.scrollToTop(10);
    });

    this.subscriptions.push(pwbSignatureSubscription);
  }
  private generateQuery = (establishData) => {
    let query = '';
    query += `accessId=${encodeURIComponent(establishData.accessId)}`;
    query += `&merchantId=${encodeURIComponent(establishData.merchantId)}`;
    if (establishData.description) {
      query += `&description=${encodeURIComponent(establishData.description)}`;
    }
    // query += `&description=${encodeURIComponent(establishData.description ? establishData.description : '')}`;
    if (establishData.currency) {
      query += `&currency=${encodeURIComponent(establishData.currency)}`;
    }
    // query += `&currency=${encodeURIComponent(establishData.currency ? establishData.currency : '')}`;
    if (establishData.amount) {
      query += `&amount=${encodeURIComponent(establishData.amount)}`;
    }
    // query += `&amount=${encodeURIComponent(establishData.amount ? establishData.amount : '')}`;
    if (establishData.displayAmount) {
      query += `&displayAmount=${encodeURIComponent(establishData.displayAmount)}`;
    }
    // query += `&displayAmount=${encodeURIComponent(establishData.displayAmount ? establishData.displayAmount : '')}`;
    if (establishData.minimumBalance) {
      query += `&minimumBalance=${encodeURIComponent(establishData.minimumBalance)}`;
    }
    // query += `&minimumBalance=${encodeURIComponent(establishData.minimumBalance ? establishData.minimumBalance : '')}`;
    query += `&merchantReference=${encodeURIComponent(establishData.merchantReference)}`;
    query += `&paymentType=${encodeURIComponent(establishData.paymentType)}`;
    if (establishData.timeZone) {
      query += `&timeZone=${encodeURIComponent(establishData.timeZone)}`;
    }
    // query += `&timeZone=${encodeURIComponent(establishData.timeZone ? establishData.timeZone : '')}`;

    if (establishData.paymentType === 'Recurring' && establishData.recurrence) {
      if (establishData.recurrence.startDate) query += `&recurrence.startDate=${encodeURIComponent(establishData.recurrence.startDate)}`;
      if (establishData.recurrence.endDate) query += `&recurrence.endDate=${encodeURIComponent(establishData.recurrence.endDate)}`;
      if (establishData.recurrence.frequency) query += `&recurrence.frequency=${encodeURIComponent(establishData.recurrence.frequency)}`;
      if (establishData.recurrence.frequencyUnit) query += `&recurrence.frequencyUnit=${encodeURIComponent(establishData.recurrence.frequencyUnit)}`;
      if (establishData.recurrence.frequencyUnitType) query += `&recurrence.frequencyUnitType=${encodeURIComponent(establishData.recurrence.frequencyUnitType)}`;
      if (establishData.recurrence.recurringAmount) query += `&recurrence.recurringAmount=${encodeURIComponent(establishData.recurrence.recurringAmount)}`;
      if (establishData.recurrence.automaticCapture) query += `&recurrence.automaticCapture=${encodeURIComponent(establishData.recurrence.automaticCapture)}`;
    }

    if (establishData.verification) {
      if (establishData.verification.status) query += `&verification.status=${encodeURIComponent(establishData.verification.status)}`;
      if (establishData.verification.verifyCustomer) query += `&verification.verifyCustomer=${encodeURIComponent(establishData.verification.verifyCustomer)}`;
    }

    if (establishData.customer) {
      if (establishData.customer.customerId) query += `&customer.customerId=${encodeURIComponent(establishData.customer.customerId)}`;
      if (establishData.customer.externalId) query += `&customer.externalId=${encodeURIComponent(establishData.customer.externalId)}`;
      if (establishData.customer.name) query += `&customer.name=${encodeURIComponent(establishData.customer.name)}`;
      if (establishData.customer.vip !== undefined) query += `&customer.vip=${encodeURIComponent(establishData.customer.vip)}`;
      if (establishData.customer.taxId) query += `&customer.taxId=${encodeURIComponent(establishData.customer.taxId)}`;
      if (establishData.customer.driverLicense) {
        if (establishData.customer.driverLicense.number) query += `&customer.driverLicense.number=${encodeURIComponent(establishData.customer.driverLicense.number)}`;
        if (establishData.customer.driverLicense.state) query += `&customer.driverLicense.state=${encodeURIComponent(establishData.customer.driverLicense.state)}`;
      }
      if (establishData.customer.address) {
        if (establishData.customer.address.address1) query += `&customer.address.address1=${encodeURIComponent(establishData.customer.address.address1)}`;
        if (establishData.customer.address.address2) query += `&customer.address.address2=${encodeURIComponent(establishData.customer.address.address2)}`;
        if (establishData.customer.address.city) query += `&customer.address.city=${encodeURIComponent(establishData.customer.address.city)}`;
        if (establishData.customer.address.state) query += `&customer.address.state=${encodeURIComponent(establishData.customer.address.state)}`;
        if (establishData.customer.address.zip) query += `&customer.address.zip=${encodeURIComponent(establishData.customer.address.zip)}`;
        if (establishData.customer.address.country) query += `&customer.address.country=${encodeURIComponent(establishData.customer.address.country)}`;
      }
      if (establishData.customer.phone) query += `&customer.phone=${encodeURIComponent(establishData.customer.phone)}`;
      if (establishData.customer.email) query += `&customer.email=${encodeURIComponent(establishData.customer.email)}`;
      if (establishData.customer.balance) query += `&customer.balance=${encodeURIComponent(establishData.customer.balance)}`;
      if (establishData.customer.currency) query += `&customer.currency=${encodeURIComponent(establishData.customer.currency)}`;
      if (establishData.customer.enrollDate) query += `&customer.enrollDate=${encodeURIComponent(establishData.customer.enrollDate)}`;
      if (establishData.customer.dateOfBirth) query += `&customer.dateOfBirth=${encodeURIComponent(establishData.customer.dateOfBirth)}`;
    }

    if (establishData.account) {
      if (establishData.account.nameOnAccount) query += `&account.nameOnAccount=${encodeURIComponent(establishData.account.nameOnAccount)}`;
      if (establishData.account.name) query += `&account.name=${encodeURIComponent(establishData.account.name)}`;
      if (establishData.account.type) query += `&account.type=${encodeURIComponent(establishData.account.type)}`;
      if (establishData.account.profile) query += `&account.profile=${encodeURIComponent(establishData.account.profile)}`;
      if (establishData.account.accountNumber) query += `&account.accountNumber=${encodeURIComponent(establishData.account.accountNumber)}`;
      if (establishData.account.routingNumber) query += `&account.routingNumber=${encodeURIComponent(establishData.account.routingNumber)}`;
    }

    if (establishData.transactionId) query += `&transactionId=${encodeURIComponent(establishData.transactionId)}`;

    return query;
  }



}
